import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Button, FormField, Grid, Select, Text, TextArea, TextInput } from "grommet";
import * as React from "react";
import Avatar from "react-avatar";
import { useNavigate } from "react-router-dom";
import CustomButton from "../components/CustomButton";
import Flag from "../components/Flag";
import NavigateToPath from "../components/NavigateToPath";
import ThemeBuilder from "../components/ThemeBuilder";
import OrganizationSearch from "../organizations/OrganizationSearch";
import { Organization } from "../organizations/OrganizationStore";
import GameDetails from "./GameDetails";
import { createGame, CreateGameRequest } from "./GamesStore";

const CreateGame = () => {
    let [organization, setOrganization] = React.useState({} as Organization);

    let [game, setGame] = React.useState({} as CreateGameRequest);

    let [isCreating, setIsCreating] = React.useState(false);

    let [error, setError] = React.useState("");

    let navigate = useNavigate();

    let create = () => {
        setIsCreating(true);
        createGame(game).then(
            (result) => {
                navigate(`/admin/games/${result.result.id}`,{replace:true});
            },
            (error) => {
                setError(error);
            }
        );
    };

    const onChange = (game) => {
        setGame({ ...game, organizationID: organization.id });
    };

    React.useEffect(() => {
        setGame({ ...game, organizationID: organization.id });
    }, [organization.id]);

    return (
        <div>
            <Box direction="row">
                <h1>Add Game </h1>
                <NavigateToPath path="admin/games/create"></NavigateToPath>
            </Box>
            <Box width={{ max: "400px" }} pad="small" round="5px" background={"background"}>
                <OrganizationSearch onSelect={(organization) => setOrganization(organization)}></OrganizationSearch>
                <GameDetails game={game} isBusy={isCreating} onChange={onChange}></GameDetails>
                <br />
                <Box direction="row">
                    {/* @ts-ignore */}
                    <CustomButton primary icon={<FontAwesomeIcon size="xl" icon={["fad", "users-medical"]}></FontAwesomeIcon>} onClick={create} disabled={isCreating || !game.name} label="Create"></CustomButton>
                </Box>

                <Box>{error && <pre>{JSON.stringify(error, null, 2)}</pre>}</Box>
            </Box>
        </div>
    );
};

export default CreateGame;
